import { Palette } from 'lucide-react';
import { AnswerQualityHint } from './AnswerQualityHint';

interface Step11Data {
  image_color_preferences: string;
  no_color_preference?: boolean;
}

interface Step11ImageColorsProps {
  data: Step11Data;
  onChange: (data: Step11Data) => void;
}

export function Step11ImageColors({ data, onChange }: Step11ImageColorsProps) {
  const noPreference = data.no_color_preference ?? false;

  const handleCheckboxChange = (checked: boolean) => {
    onChange({
      ...data,
      no_color_preference: checked,
      image_color_preferences: checked ? '' : data.image_color_preferences,
    });
  };

  return (
    <div className="space-y-6">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
          <Palette className="w-4 h-4" />
          Heb je kleurvoorkeuren?
        </label>
        <input
          type="text"
          value={data.image_color_preferences}
          onChange={(e) => onChange({ ...data, image_color_preferences: e.target.value })}
          disabled={noPreference}
          className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all text-lg disabled:bg-gray-100 disabled:cursor-not-allowed"
          placeholder="Warme tinten: bruin, beige, goud. Accent: donkergroen"
          autoFocus={!noPreference}
        />
        {!noPreference && <AnswerQualityHint length={data.image_color_preferences.length} />}
      </div>

      <div className="flex items-center gap-2">
        <input
          type="checkbox"
          id="no-color-preference"
          checked={noPreference}
          onChange={(e) => handleCheckboxChange(e.target.checked)}
          className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
        />
        <label htmlFor="no-color-preference" className="text-sm text-gray-700 cursor-pointer">
          Geen specifieke kleurvoorkeur
        </label>
      </div>
    </div>
  );
}
